import { chatHcpFullAccessPolicy } from './chat-hcp-full-access.js';
import { defineBuiltinRole } from './types.js';

/**
 * A user with national scope in an application: they see every HCP and national-level data,
 * not only what their territory covers. Replaces the brand-level "national" access flag.
 */
export const nationalUserRole = defineBuiltinRole({
  key: 'builtin:national-user',
  name: 'National User',
  description: 'A person using an application with national scope, seeing every HCP rather than only their own.',
  policies: [chatHcpFullAccessPolicy],
});
